import {
	CONNECTION_CHANGE_WEBSOCKET_STATUS,
	CONNECTION_PROFILE_LOAD_STATUS, CONNECTION_UPDATE_STARTUP_EVENTS,
} from '../actions/connection';

import { Dashboard } from 'components/Dashboard';
import ConnectionStatus from "../../../components/contstants/ConnectionStatus";


const initialState = {
	initialSetupSteps: [],
	initialSetupStepsRemaining: new Map(),
	readyState: null,
	message: null,
	websocketIsReady: false,
};

export default (state = initialState, action) => {
	switch(action.type) {
		case CONNECTION_UPDATE_STARTUP_EVENTS: {
			return {
				...state,
				initialSetupSteps: Array.from(action.payload.all),
				initialSetupStepsRemaining: new Map(action.payload.remaining),
			};
		}
		case CONNECTION_PROFILE_LOAD_STATUS:
			return {
				...state,
				message: action.payload,
			};
		case CONNECTION_CHANGE_WEBSOCKET_STATUS:
			const value = action.payload;
			let websocketIsReady = value === ConnectionStatus.AUTHENTICATED_AND_OPEN;
			return {
				...state,
				readyState: action.payload,
				websocketIsReady
			};
		default:
			return state;
	}
}